/* ============================================================
   Biwa Wave — sequence-based variant media grouping.
   Each variant's assigned image = the head (anchor) of its group.
   Following (unassigned) media belong to that group until the
   next anchor appears. Selecting a variant shows only its group.

   Data: <script class="bw-media-groups"> maps
     "{section}-{mediaId}" -> [ [val, val, ...], ... ]
   Each inner array is an "identity": the option values that must ALL
   be currently selected for the media to show. Multiple identities =
   the media is shared by several variants (show if ANY matches).
   [] (empty) = common image -> always shown.

   Default products group by colour (identity = [colour]).
   Products tagged 'gallery-size' group by the full variant
   (identity = [size, colour, ...]) so each size shows only its own images.
   Re-applies after Dawn rebuilds the gallery on variant change.
   ============================================================ */
(function () {
  'use strict';

  function loadGroups() {
    var out = {};
    document.querySelectorAll('script.bw-media-groups').forEach(function (s) {
      try {
        var o = JSON.parse((s.textContent || '').trim());
        Object.keys(o).forEach(function (k) { out[k] = o[k]; });
      } catch (e) {}
    });
    return out;
  }

  function selectedValues() {
    var set = {};
    document
      .querySelectorAll(
        'variant-selects input:checked, .product-form__input input:checked, .product-form__input select'
      )
      .forEach(function (el) {
        var v = (el.value || '').trim();
        if (v) set[v] = true;
      });
    return set;
  }

  function apply() {
    var groups = loadGroups();
    if (!Object.keys(groups).length) return;
    var sel = selectedValues();

    var items = document.querySelectorAll(
      'media-gallery li[data-media-id], .thumbnail-list li[data-target], li.thumbnail-list__item[data-target]'
    );
    if (!items.length) return;

    // First pass: decide visibility without mutating the DOM yet.
    var decisions = [];
    var anyGrouped = false;
    var anyShown = false;
    items.forEach(function (li) {
      var key = li.getAttribute('data-media-id') || li.getAttribute('data-target');
      if (!key) { decisions.push([li, true]); return; }
      var ids = groups[key];
      if (!ids || !ids.length) { decisions.push([li, true]); return; } // common -> always show
      anyGrouped = true;
      var show = ids.some(function (idv) {
        return idv.length && idv.every(function (val) { return sel[val]; });
      });
      if (show) anyShown = true;
      decisions.push([li, show]);
    });

    // Safety: if every grouped item would be hidden (e.g. selected values could
    // not be resolved), leave the gallery untouched rather than blank it.
    if (anyGrouped && !anyShown) return;

    decisions.forEach(function (d) { d[0].style.display = d[1] ? '' : 'none'; });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 50); }

  document.addEventListener(
    'change',
    function (e) {
      var el = e.target;
      if (el && el.closest && el.closest('variant-selects, .product-form, .product-form__input')) schedule();
    },
    true
  );

  function observe() {
    document.querySelectorAll('media-gallery ul, .thumbnail-slider, .thumbnail-list').forEach(function (ul) {
      if (ul.__bwvm) return;
      ul.__bwvm = 1;
      try { new MutationObserver(schedule).observe(ul, { childList: true }); } catch (e) {}
    });
  }

  function init() { observe(); apply(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
